/* ==========================================================================
   VaultFit Theme — Core JavaScript
   Vanilla JS only. No external libraries or frameworks. No cart, no drawer,
   no mini-cart: the product form submits straight to Shopify's checkout.
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ------------------------------------------------------------------
     Scroll reveal (fade-in)
  ------------------------------------------------------------------ */
  function initScrollReveal() {
    var targets = document.querySelectorAll('.fade-in');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, index) {
          if (entry.isIntersecting) {
            var el = entry.target;
            setTimeout(function () {
              el.classList.add('is-visible');
            }, (index % 6) * 60);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------------
     Mobile navigation
  ------------------------------------------------------------------ */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var isOpen = !nav.hidden;
      nav.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ------------------------------------------------------------------
     Search modal
  ------------------------------------------------------------------ */
  function initSearchModal() {
    var modal = document.getElementById('vf-search-modal');
    var openBtns = document.querySelectorAll('[data-search-open]');
    var closeBtns = modal ? modal.querySelectorAll('[data-search-close]') : [];
    if (!modal) return;

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.hidden = false;
        var input = modal.querySelector('input[type="search"]');
        if (input) input.focus();
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { modal.hidden = true; });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) modal.hidden = true;
    });
  }

  /* ------------------------------------------------------------------
     Accordion (FAQ + product details)
  ------------------------------------------------------------------ */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-accordion-trigger]');
      if (!trigger) return;
      var item = trigger.closest('.faq-item');
      if (!item) return;
      var isOpen = item.hasAttribute('data-open');
      if (isOpen) {
        item.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        item.setAttribute('data-open', '');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ------------------------------------------------------------------
     Money formatting (client-side only, used for variant price swap)
  ------------------------------------------------------------------ */
  function formatMoney(cents) {
    var format = (window.vaultfitStrings && window.vaultfitStrings.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var formatted = parts.join(',');
    if (format.indexOf('amount_no_decimals') !== -1) formatted = parts[0];
    return format.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, formatted);
  }

  /* ------------------------------------------------------------------
     Product form: quantity, variant swatches, direct-to-checkout submit
     No AJAX, no /cart calls from theme JS — the form posts natively and
     Shopify's own product-form + name="checkout" handles adding the
     variant and redirecting straight to the configured checkout.
  ------------------------------------------------------------------ */
  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var section = form.closest('.main-product');
      if (!section) return;

      var variantsScript = section.querySelector('[data-product-variants]');
      var variants = [];
      try { variants = variantsScript ? JSON.parse(variantsScript.textContent) : []; } catch (e) { variants = []; }

      var variantIdInput = form.querySelector('[data-product-variant-id]');
      var submitBtn = form.querySelector('[data-buy-now-button]');
      var submitText = form.querySelector('[data-buy-now-text]');

      /* Quantity stepper */
      var qtyInput = form.querySelector('[data-quantity-input]');
      var minusBtn = form.querySelector('[data-quantity-minus]');
      var plusBtn = form.querySelector('[data-quantity-plus]');
      if (minusBtn && qtyInput) {
        minusBtn.addEventListener('click', function () {
          var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          qtyInput.value = val;
        });
      }
      if (plusBtn && qtyInput) {
        plusBtn.addEventListener('click', function () {
          var val = (parseInt(qtyInput.value, 10) || 1) + 1;
          qtyInput.value = val;
        });
      }

      /* Variant option swatches */
      var optionGroups = form.querySelectorAll('[data-product-option]');
      function getSelectedOptions() {
        var selected = [];
        optionGroups.forEach(function (group) {
          var active = group.querySelector('.product-form__swatch.is-selected');
          selected.push(active ? active.getAttribute('data-option-value') : null);
        });
        return selected;
      }

      function findMatchingVariant() {
        var selected = getSelectedOptions();
        return variants.find(function (variant) {
          return variant.options.every(function (opt, idx) { return opt === selected[idx]; });
        });
      }

      function applyVariant(variant) {
        if (!variant) {
          if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
          if (submitText) submitText.textContent = (window.vaultfitStrings && window.vaultfitStrings.unavailable) || 'Indisponivel';
          return;
        }
        if (variantIdInput) variantIdInput.value = variant.id;

        var priceWrap = section.querySelector('[data-product-price]');
        if (priceWrap) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceWrap.innerHTML =
              '<span class="price price--sale">' + formatMoney(variant.price) + '</span>' +
              '<span class="price price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
          } else {
            priceWrap.innerHTML = '<span class="price">' + formatMoney(variant.price) + '</span>';
          }
        }

        if (variant.featured_media) {
          var targetSlide = section.querySelector('[data-gallery-slide][data-media-id="' + variant.featured_media.id + '"]');
          if (targetSlide) {
            section.querySelectorAll('[data-gallery-slide]').forEach(function (s) { s.classList.remove('is-active'); });
            targetSlide.classList.add('is-active');
            section.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
              t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(variant.featured_media.id));
            });
          }
        }

        if (submitBtn) {
          if (variant.available) {
            submitBtn.removeAttribute('disabled');
            if (submitText) submitText.textContent = (window.vaultfitStrings && window.vaultfitStrings.buyNow) || 'Comprar Agora';
          } else {
            submitBtn.setAttribute('disabled', 'disabled');
            if (submitText) submitText.textContent = (window.vaultfitStrings && window.vaultfitStrings.soldOut) || 'Esgotado';
          }
        }
      }

      optionGroups.forEach(function (group) {
        var swatches = group.querySelectorAll('.product-form__swatch');
        var labelValue = group.querySelector('[data-option-selected]');
        swatches.forEach(function (swatch) {
          swatch.addEventListener('click', function () {
            swatches.forEach(function (s) { s.classList.remove('is-selected'); });
            swatch.classList.add('is-selected');
            if (labelValue) labelValue.textContent = swatch.getAttribute('data-option-value');
            applyVariant(findMatchingVariant());
          });
        });
      });

      /* No preventDefault: submitting the form navigates the browser
         straight to Shopify's checkout (name="checkout" on the submit
         button), matching the official Buy Now flow. */
      form.addEventListener('submit', function () {
        if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
        if (submitText) submitText.textContent = (window.vaultfitStrings && window.vaultfitStrings.redirecting) || submitText.textContent;
      });
    });
  }

  /* ------------------------------------------------------------------
     Product gallery: thumbnails, swipe (mobile) and zoom lightbox
  ------------------------------------------------------------------ */
  function initGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));

      function activateByMediaId(mediaId) {
        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === mediaId);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-media-id') === mediaId);
        });
      }

      function activeIndex() {
        return slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      }

      function goToOffset(offset) {
        if (!slides.length) return;
        var next = (activeIndex() + offset + slides.length) % slides.length;
        activateByMediaId(slides[next].getAttribute('data-media-id'));
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateByMediaId(thumb.getAttribute('data-media-id'));
        });
      });

      /* Swipe support (mobile) */
      var mainEl = gallery.querySelector('.product-gallery__main');
      if (mainEl) {
        var touchStartX = null;
        mainEl.addEventListener('touchstart', function (e) {
          touchStartX = e.changedTouches[0].clientX;
        }, { passive: true });
        mainEl.addEventListener('touchend', function (e) {
          if (touchStartX === null) return;
          var delta = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(delta) > 40) goToOffset(delta < 0 ? 1 : -1);
          touchStartX = null;
        }, { passive: true });
      }

      /* Zoom lightbox (desktop + mobile) */
      gallery.querySelectorAll('[data-gallery-zoom-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          openLightbox(trigger.getAttribute('data-zoom-src'), gallery);
        });
      });
    });
  }

  var Lightbox = {
    el: null,
    imgEl: null,
    gallery: null,

    init: function () {
      this.el = document.getElementById('vf-lightbox');
      if (!this.el) return;
      this.imgEl = this.el.querySelector('[data-lightbox-image]');

      var self = this;
      this.el.querySelector('[data-lightbox-close]').addEventListener('click', function () { self.close(); });
      this.el.addEventListener('click', function (e) {
        if (e.target === self.el) self.close();
      });
      this.el.querySelector('[data-lightbox-prev]').addEventListener('click', function () { self.step(-1); });
      this.el.querySelector('[data-lightbox-next]').addEventListener('click', function () { self.step(1); });
      document.addEventListener('keydown', function (e) {
        if (self.el.hidden) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'ArrowLeft') self.step(-1);
        if (e.key === 'ArrowRight') self.step(1);
      });
    },

    open: function (src, gallery) {
      if (!this.el) return;
      this.gallery = gallery;
      this.imgEl.src = src;
      this.el.hidden = false;
    },

    close: function () {
      if (!this.el) return;
      this.el.hidden = true;
      this.imgEl.src = '';
    },

    step: function (offset) {
      if (!this.gallery) return;
      var triggers = Array.prototype.slice.call(this.gallery.querySelectorAll('[data-gallery-zoom-trigger]'));
      var current = triggers.findIndex(function (t) { return t.getAttribute('data-zoom-src') === this.imgEl.src.replace(location.origin, ''); }.bind(this));
      if (current === -1) current = 0;
      var next = (current + offset + triggers.length) % triggers.length;
      if (triggers[next]) this.imgEl.src = triggers[next].getAttribute('data-zoom-src');
    }
  };

  function openLightbox(src, gallery) {
    Lightbox.open(src, gallery);
  }

  /* ------------------------------------------------------------------
     Password recovery toggle on login page
  ------------------------------------------------------------------ */
  function initRecoverToggle() {
    var toggle = document.querySelector('[data-recover-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      var recoverForm = document.querySelector('.customer-auth__recover');
      if (recoverForm) recoverForm.style.display = recoverForm.style.display === 'block' ? 'none' : 'block';
    });
  }

  /* ------------------------------------------------------------------
     Init
  ------------------------------------------------------------------ */
  window.vaultfitStrings = window.vaultfitStrings || {};

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initMobileNav();
    initSearchModal();
    initAccordions();
    Lightbox.init();
    initProductForms();
    initGalleries();
    initRecoverToggle();
  });
})();
